export function createActionConstants(actionName) {
	let constants = {};
	['REQUESTED', 'SUCCEEDED', 'FAILED']
		.map(result => actionName.toUpperCase() + '_' + result)
		.forEach(key => {
			constants[key] = key;
		});
	return constants;
}


export function makeActionCreator(type, ...argNames) {
    return function (...args) {
        const action = { type };
        argNames.forEach((arg, index) => {
            action[argNames[index]] = args[index]
        });
        return action
    }
}





// WEBPACK FOOTER //
// ./src/redux/actions/actionsHelper.js